import { excuseApi } from '../commons/http';

const ADJUST_TYPE = { up: 2, down: 3, info: 4 };

/** HDDT government-invoice model + lifecycle calls (FINV-02-S06/S07). */
class GovernmentInvoice {
  constructor(data = {}) {
    this.mapData(data);
  }

  mapData(data = {}) {
    this.id = data.id;
    this.invoice_id = data.invoice_id;
    this.order_id = data.order_id;
    this.related_gov_invoice_id = data.related_gov_invoice_id;
    this.hddt_ma_so_hdon = data.hddt_ma_so_hdon;
    this.hddt_khmsh_don = data.hddt_khmsh_don;
    this.hddt_khh_don = data.hddt_khh_don;
    this.hddt_sh_don = data.hddt_sh_don;
    this.hddt_ma_tra_cuu = data.hddt_ma_tra_cuu;
    this.hddt_nlap = data.hddt_nlap;
    this.hddt_loai_hdon = data.hddt_loai_hdon;
    this.hddt_tch_don = data.hddt_tch_don;
    this.hddt_buyer_name = data.hddt_buyer_name;
    this.hddt_buyer_tax_code = data.hddt_buyer_tax_code;
    this.hddt_total_before_tax = data.hddt_total_before_tax;
    this.hddt_tax_amount = data.hddt_tax_amount;
    this.hddt_total_amount = data.hddt_total_amount;
    this.hddt_status = data.hddt_status;
    this.hddt_pdf_url = data.hddt_pdf_url;
    this.hddt_xml_url = data.hddt_xml_url;
    this.cancel_reason = data.cancel_reason;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    return this;
  }

  async getById(id) {
    const res = await excuseApi({ path: `/government-invoices/${id}`, method: 'GET' });
    if (res.status === 200) {
      this.mapData(res.data.data);
      return res.data.data;
    }
    return null;
  }

  async sign() {
    const res = await excuseApi({ path: `/government-invoices/${this.id}/sign`, method: 'POST' });
    if (res.status === 200) {
      this.mapData(res.data.data);
      return res.data.data;
    }
    return null;
  }

  async cancel(reason) {
    const res = await excuseApi({
      path: `/government-invoices/${this.id}/cancel`, method: 'POST', body: { reason },
    });
    if (res.status === 200) {
      this.mapData(res.data.data);
      return res.data.data;
    }
    return null;
  }

  async adjust({ adjust_type, line_items, reason }) {
    const res = await excuseApi({
      path: `/government-invoices/${this.id}/adjust`, method: 'POST',
      body: { tch_don: ADJUST_TYPE[adjust_type], line_items, reason },
    });
    return res && (res.status === 200 || res.status === 201) ? res.data.data : null;
  }

  async replace({ line_items, buyer_info }) {
    const res = await excuseApi({
      path: `/government-invoices/${this.id}/replace`, method: 'POST',
      body: { line_items, buyer_info },
    });
    return res && (res.status === 200 || res.status === 201) ? res.data.data : null;
  }

  async download() {
    // Backend returns the PDF as a binary file (application/pdf).
    const res = await excuseApi({
      path: `/government-invoices/${this.id}/download`, method: 'POST', responseType: 'blob',
    });
    return res.status === 200 ? res.data : null;   // a Blob
  }

  /** Issue the HDDT draft for a delivered ORDER (S13). Idempotent: 200 = existed. */
  async createForOrder(orderId) {
    const res = await excuseApi({
      path: '/government-invoices', method: 'POST', body: { order_id: orderId },
    });
    if (res && (res.status === 200 || res.status === 201)) {
      this.mapData(res.data.data);
      return res.data.data;
    }
    return null;
  }

  /** The order's active HDDT, or null. */
  async fetchByOrder(orderId) {
    const res = await excuseApi({
      path: `/government-invoices?order_id=${orderId}`, method: 'GET',
    });
    if (res && res.status === 200 && res.data.data) {
      this.mapData(res.data.data);
      return res.data.data;
    }
    return null;
  }
}

export default GovernmentInvoice;
export { ADJUST_TYPE };
